// @ts-nocheck
import * as React from 'react';
import {
  useForm,
  UseFormMethods,
  UnpackNestedValue,
  DeepPartial,
  FormProvider,
} from 'react-hook-form';

import { StyledFormContainer } from './styled';

export const FormContainer = <
  TFormValues extends Record<string, any> = Record<string, any>,
>({
  children,
  onSubmit,
  defaultValues,
  id,
}: FormContainerProps<TFormValues>) => {
  const methods = useForm<TFormValues>({
    mode: 'onSubmit',
    defaultValues,
  });

  return (
    <StyledFormContainer
      id={id}
      onSubmit={methods.handleSubmit((values) => onSubmit(values, methods))}
    >
      <FormProvider {...methods}>{children(methods)}</FormProvider>
    </StyledFormContainer>
  );
};

export type FormContainerProps<TFormValues> = {
  id?: string;
  defaultValues?: UnpackNestedValue<DeepPartial<TFormValues>>;
  onSubmit: (data: TFormValues, methods: UseFormMethods) => any | Promise<any>;
  children: (methods: UseFormMethods<TFormValues>) => React.ReactNode;
};
